import React from "react";
import styles from "./Input.module.scss";
import { Controller } from "react-hook-form";
import withLabelAndError from "../withLabelAndError";

const Input = (props: any) => {
  const { control, register, validations, name, placeholder, type, ...rest } =
    props;
  const currency = localStorage.getItem("currency");
  
  const renderInput = (field = {}) => {
    const symbol =
      name.toLowerCase().includes("amount") ||
      name.toLowerCase().includes("sales") ||
      name.toLowerCase().includes("charges") ||
      name.toLowerCase().includes("balance")
        ? `${currency}`
        : name.toLowerCase().includes("percent")
        ? "%"
        : "";

    return (
      <div className={styles.inputWrapper}>
        <input
          {...field}
          {...rest}
          id={name}
          type={type || "text"}
          className={styles.inputField}
          placeholder={placeholder}
          readOnly={!!rest.onFieldClick}
          onClick={rest.onFieldClick}
          disabled={rest.isDisabled}
        />

        {symbol && (
          <div className={styles.symbolBox}>
            <span className={styles.divider}>|</span>
            <span className={styles.symbol}>{symbol}</span>
          </div>
        )}
      </div>
    );
  };

  if (control) {
    return (
      <Controller
        control={control}
        rules={validations}
        name={name}
        render={({ field }) => renderInput(field)}
      />
    );
  }

  const field = register && register(name, validations);
  return renderInput(field);
};

const InputWithLabelAndError = withLabelAndError(Input);

export default InputWithLabelAndError;
export { Input };
